const { STATUS, CHECK_ID } = require('../constants');
const { ottuPgMethods } = require('./jazz');

function runOttuPgCheck(ctx, apiConfig) {
  const methods = ottuPgMethods(ctx);
  const apiActive = apiConfig ? !!apiConfig.is_active : null;
  const evidence = {
    ottuPgMethodCount: methods.length,
    methods: methods.map((m) => m.code),
    apiActive,
  };
  let status = STATUS.PASS;
  let detail = 'Ottu PG payment method(s) configured';
  if (!methods.length) {
    status = STATUS.FAIL;
    detail = 'no Ottu PG payment method is configured for this merchant';
  } else if (apiConfig && !apiConfig.is_active) {
    status = STATUS.FAIL;
    detail = 'Ottu PG is configured locally but the backend reports it inactive';
  }
  return { id: CHECK_ID.OTTU_PG, status, detail, evidence };
}

module.exports = { runOttuPgCheck };
